import { Box } from '@mui/material';
import { RenderTable } from '../../../../../components/ui';
import TBody from './TBody';
import THead from './THead';
interface IProps {
  moduleData: any;
  isView: boolean;
  processData: any;
}

const TController = ({ moduleData, isView, processData }: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            processData,
          }}
        />
        <TBody {...{ moduleData, processData, isView }} />
      </RenderTable>
    </Box>
  );
};

export default TController;
